import { AICollaborationTool } from '../components/AICollaborationTool';

export default function AIAssistantPage({ role }) {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-semibold">AI Assistant</h1>
          <p className="text-muted-foreground mt-1">
            Chat generally, use the agent selector for structured planning (financial planning,
            investments, retirement & tax, estate & risk), and run one-click Quick Actions below
          </p>
        </div>
      </div>
      <AICollaborationTool role={role} />
    </div>
  );
}